import { DollarOutlined, RiseOutlined, TruckOutlined } from "@ant-design/icons";
import { Col, Row, Table } from "antd";

import { useTranslation } from "react-i18next";

import { usePermission } from "../../../hooks/usePermission";

// `data.title` (SEA Freight / LAND Transport) comes from BE — kept English per §7.8 (FE does not invent labels)
const FreightCard = ({ data }) => {
  const { t } = useTranslation("dashboard");
  const regionColumns = [
    { title: t("Metric.Region"), dataIndex: "region", key: "region", width: 64 },
    { title: t("Metric.Baht"), dataIndex: "baht", key: "baht", align: "right" },
    { title: t("Metric.CBM"), dataIndex: "cbm", key: "cbm", align: "right" },
    { title: t("Metric.KG"), dataIndex: "kg", key: "kg", align: "right" },
  ];

  return (
    <div className="es-metric-card es-metric-card--freight">
      <div className="es-freight-header">
        <div className="es-metric-card-title">
          <span className="es-metric-icon es-metric-icon--freight">
            <TruckOutlined />
          </span>
          {data.title}
        </div>
        <div className="es-metric-figures">
          <div className="es-metric-figure">
            <span className="es-metric-figure-label">{t("Metric.Baht")}</span>
            <span className="es-metric-figure-value">{data.baht}</span>
          </div>
          <div className="es-metric-figure">
            <span className="es-metric-figure-label">{t("Metric.CBM")}</span>
            <span className="es-metric-figure-value">{data.cbm}</span>
          </div>
          <div className="es-metric-figure">
            <span className="es-metric-figure-label">{t("Metric.KG")}</span>
            <span className="es-metric-figure-value">{data.kg}</span>
          </div>
          {data.trend && (
            <span className="es-metric-trend">
              <RiseOutlined /> {data.trend}
            </span>
          )}
        </div>
      </div>
      <div className="es-freight-table-wrap">
        <Table
          className="es-region-table"
          columns={regionColumns}
          dataSource={data.regions}
          pagination={false}
          size="small"
          bordered
        />
      </div>
    </div>
  );
};

const OutstandingBalanceCard = ({ data }) => {
  const { t } = useTranslation("dashboard");
  const { isSuperuser } = usePermission();
  const byCustomerByCompany = data.byCustomerByCompany || [];

  return (
    <div className="es-metric-card es-metric-card--outstanding">
      <Row>
        <Col span={2}>
          <div className="es-kpi-icon" style={{ color: "#16a34a", background: "#dcfce7" }}>
            <DollarOutlined />
          </div>

          {/* <span className="pt-1 es-metric-icon es-metric-icon--balance"></span> */}
        </Col>
        <Col span={22}>
          <div className="es-kpi-body mx-7">
            <div className="es-kpi-card-title pt-0.5">{t("Metric.Outstanding_Balance")}</div>
            <div className="es-kpi-card-value es-metric-total" style={{ marginBottom: 16 }}>
              {data.total}
            </div>
            <div className="es-balance-row">
              <span>{t("Metric.By_Company")}</span>
              <strong>{data.byCompany}</strong>
            </div>
            <div className="es-balance-row">
              <span>{t("Metric.By_Customer")}</span>
              <strong>{data.byCustomer}</strong>
            </div>
            {isSuperuser && byCustomerByCompany.length > 0 && (
              <div
                className={
                  byCustomerByCompany.length > 3
                    ? "es-balance-by-company-list es-balance-by-company-list--scroll"
                    : "es-balance-by-company-list"
                }
              >
                {byCustomerByCompany.map((row) => (
                  <div key={row.code} className="es-balance-row es-balance-row--nested">
                    <span>{row.code}</span>
                    <strong>{row.amount}</strong>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

const MetricCards = ({ outstanding, sea, land }) => {
  return (
    <div className="es-metric-grid">
      <OutstandingBalanceCard data={outstanding} />
      <FreightCard data={sea} />
      <FreightCard data={land} />
    </div>
  );
};

export default MetricCards;
